import { IGridFontSizes } from 'rewire-grid';

export const defaultFontSizes: IGridFontSizes = {
  header:     '0.85em',
  body:       '0.8em',
  groupRow:   '0.95em',
  toggleMenu: '0.85em',
};
